import { render, staticRenderFns, recyclableRender, components } from "./coolc-coupon.vue?vue&type=template&id=b0f8e3b8&"
var renderjs
import script from "./coolc-coupon.vue?vue&type=script&lang=js&"
export * from "./coolc-coupon.vue?vue&type=script&lang=js&"
import style0 from "./coolc-coupon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../下载/Edge下载/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/coolc-coupon/coolc-coupon.vue"
export default component.exports